import { StarterCardChoice, toGameCardChoice } from "../constants/starterCards"
import { GameCard } from "../types/battle"

/** Два слота выбора на UI (карта 1 и карта 2). */
export type StarterCardPicksTuple = [
  StarterCardChoice | null,
  StarterCardChoice | null,
]

/** firstPick / secondPick из state — без undefined в payload. */
export function requireTwoPicks(
  picks: StarterCardPicksTuple
): [StarterCardChoice, StarterCardChoice] | null {
  const firstPick = picks[0]
  const secondPick = picks[1]
  if (!firstPick || !secondPick) return null
  if (!isValidSubmission([firstPick, secondPick])) return null
  return [firstPick, secondPick]
}

export function choiceKey(c: StarterCardChoice): string {
  return `${c.element}:${c.style}`
}

/** Превью белой стартовой карты для UI выбора (как в коллекции). */
export function starterChoiceToPreviewCard(choice: StarterCardChoice): GameCard {
  const { element, style } = toGameCardChoice(choice)
  return {
    id: `starter-preview-${choiceKey(choice)}`,
    user_id: 0,
    element,
    style,
    level: 1,
    basePower: 0,
    colorRank: "WHITE",
    isReborn: false,
    victories: 0,
    totalBattles: 0,
  }
}

export function canPickSecond(
  first: StarterCardChoice | null,
  candidate: StarterCardChoice
): boolean {
  if (!first) return true
  return choiceKey(first) !== choiceKey(candidate)
}

export function isValidSubmission(picks: StarterCardChoice[]): boolean {
  return (
    picks.length === 2 &&
    choiceKey(picks[0]) !== choiceKey(picks[1])
  )
}

export function pickSlotForOption(
  picks: [StarterCardChoice | null, StarterCardChoice | null],
  option: StarterCardChoice
): [StarterCardChoice | null, StarterCardChoice | null] {
  const key = choiceKey(option)
  if (picks[0] && choiceKey(picks[0]) === key) {
    return [picks[1], null]
  }
  if (picks[1] && choiceKey(picks[1]) === key) {
    return [picks[0], null]
  }
  if (!picks[0]) {
    return [option, picks[1]]
  }
  if (!picks[1] && canPickSecond(picks[0], option)) {
    return [picks[0], option]
  }
  if (picks[0] && canPickSecond(picks[0], option)) {
    return [picks[0], option]
  }
  return picks
}

export function filledPicks(
  picks: [StarterCardChoice | null, StarterCardChoice | null]
): StarterCardChoice[] {
  const out: StarterCardChoice[] = []
  if (picks[0]) out.push(picks[0])
  if (picks[1]) out.push(picks[1])
  return out
}

export function asStarterCardsTuple(
  picks: StarterCardChoice[]
): [StarterCardChoice, StarterCardChoice] | null {
  if (!isValidSubmission(picks)) return null
  return [picks[0], picks[1]]
}

/** Тело для API: только UPPERCASE, всегда ровно 2 элемента (axios не шлёт undefined). */
export function serializeStarterCardsForApi(
  starterCards: [StarterCardChoice, StarterCardChoice]
): [{ element: StarterCardChoice["element"]; style: StarterCardChoice["style"] }, { element: StarterCardChoice["element"]; style: StarterCardChoice["style"] }] {
  return [
    {
      element: String(starterCards[0].element).toUpperCase() as StarterCardChoice["element"],
      style: String(starterCards[0].style).toUpperCase() as StarterCardChoice["style"],
    },
    {
      element: String(starterCards[1].element).toUpperCase() as StarterCardChoice["element"],
      style: String(starterCards[1].style).toUpperCase() as StarterCardChoice["style"],
    },
  ]
}

export function mockStarterCards(
  choices: [StarterCardChoice, StarterCardChoice],
  userId = 1
): GameCard[] {
  return choices.map((choice, index) => {
    const { element, style } = toGameCardChoice(choice)
    return {
      id: `mock-${element}-${style}-${index}`,
      user_id: userId,
      element,
      style,
      level: 1,
      basePower: 0,
      colorRank: "WHITE",
      isReborn: false,
      victories: 0,
      totalBattles: 0,
    }
  })
}
